import { Injectable } from "@angular/core";
import { RtmpDestinationV2EntityRaw } from "@common/domain";
import { ApiService } from "@youm-front/api/data-access";
import { map } from "rxjs/operators";
import {
  Conf2RtmpDestinationCreateRequestDTO,
  RtmpDestinationCreateRequestDTO,
  RtmpDestinationCreateResponseDTO,
  RtmpDestinationDeleteRequestDTO,
  RtmpDestinationsListResponseDTO,
  RtmpDestinationUpdateRequestDTO,
  RtmpDestinationUpdateResponseDTO
} from "../dto";

@Injectable()
export class DestinationsService {
  constructor(private readonly apiService: ApiService) {}

  rtmpDestinationCreate(
    rtmpDestinationCreateRequestDTO:
      | Conf2RtmpDestinationCreateRequestDTO
      | RtmpDestinationCreateRequestDTO
  ) {
    return this.apiService
      .post<{ destination: RtmpDestinationV2EntityRaw }>(
        "destinations",
        rtmpDestinationCreateRequestDTO
      )
      .pipe(map((_) => new RtmpDestinationCreateResponseDTO(_)));
  }

  rtmpDestinationDelete(
    rtmpDestinationDeleteRequestDTO: RtmpDestinationDeleteRequestDTO
  ) {
    const { id } = rtmpDestinationDeleteRequestDTO.value;

    return this.apiService.delete<void>(`destinations/${id}?type=rtmp`);
  }

  rtmpDestinationUpdate(
    rtmpDestinationUpdateRequestDTO: RtmpDestinationUpdateRequestDTO
  ) {
    const { id } = rtmpDestinationUpdateRequestDTO.value;

    return this.apiService
      .put<{ destination: RtmpDestinationV2EntityRaw }>(
        `destinations/${id}`,
        rtmpDestinationUpdateRequestDTO
      )
      .pipe(map((_) => new RtmpDestinationUpdateResponseDTO(_)));
  }

  rtmpDestinationsList() {
    return this.apiService
      .get<{ destinations: RtmpDestinationV2EntityRaw[] }>(
        "destinations?type=rtmp"
      )
      .pipe(
        map(
          (_) =>
            new RtmpDestinationsListResponseDTO({
              destinations: _.destinations
            })
        )
      );
  }
}
